export {default} from './Confetti';
